export {default} from './Confetti';
